var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 3.87871C1.31658 3.48818 0.683418 3.48818 0.292893 3.87871C-0.0976311 4.26923 -0.0976311 4.9024 0.292893 5.29292L1.70711 3.87871ZM2.87868 7.87871L3.58579 8.58582L5 7.1716L4.29289 6.46449L2.87868 7.87871ZM0.292893 5.29292L2.87868 7.87871L4.29289 6.46449L1.70711 3.87871L0.292893 5.29292Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 1.70711C11.6836 1.31658 11.6836 0.683418 11.293 0.292893C10.9025 -0.0976311 10.2694 -0.0976311 9.87883 0.292893L11.293 1.70711ZM3.29304 6.87868L2.58594 7.58579L4.00015 9L4.70726 8.29289L3.29304 6.87868ZM9.87883 0.292893L3.29304 6.87868L4.70726 8.29289L11.293 1.70711L9.87883 0.292893Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.b89d1bca00ebe368e976c6ab71f366ef.svg";
export { ForwardRef as ReactComponent };